import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BlankImg from "../../assets/images/blank.jpg";
import { ImageWithFallback, useDebounce } from "../../helper/helper";
import Pagination from "../../component/Pagination";
import $ from "jquery";
import moment from "moment";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net-responsive-dt/css/responsive.dataTables.css";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";
import "datatables.net";
import "datatables.net-responsive";
import "datatables.net-buttons";
import {
  Box,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  // Checkbox,
  Button,
  Modal,
  Link,
  TableSortLabel,
} from "@mui/material";
import DeleteIcon from "../../assets/images2/deleteIcon.svg";
import { fetchTournamentData } from "../../action/tournamentsAction";
import { defineLocale } from "moment/moment";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SearchIcon from "@mui/icons-material/Search";
import CheckBox from "../../component/CheckBox";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import TournamentVideoDeleteModal from "../../component/Modals/DeleteModal";
// import ViewTournament from "../../../component/Modals/ViewTournament";
import ViewClub from "../../component/Modals/ViewClub";
import LisitingSkeleton from "../common/LisitingSkeleton";
import { getAdminAllClubsApi } from "../../features/admin/allClubs.slice";
import VideoCell from "../../component/admin/globalVideoCellComponent/Index";

const goalsColumn = [
  { id: "tournament_select", label: "", minWidth: 105 },
  { id: "title", label: "TITLE", minWidth: 105 },
  { id: "tournament_visibility", label: "VISIBILITY", minWidth: 500 },
  { id: "tournament_category", label: "CATEGORY", minWidth: 210 },
  // { id: "club", label: "CLUB NAME", minWidth: 180 },
  { id: "region", label: "REGION", minWidth: 290 },
  // { id: "tournament_from", label: "FROM", minWidth: 290 },
  { id: "tournament_videos", label: "VIDEOS", minWidth: 290 },
  { id: "tournament_createedAt", label: "CREATED AT", minWidth: 290 },
  { id: "tournament_actions", label: "ACTIONS", minWidth: 290 },
];

const columnsToSort = ["title", "club", "region"];

export default function Goals() {
  const goalData = useSelector((state) => state.allAdminClub);
  const token = useSelector((state) => state.auth.token);
  const [goals, setGoals] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const dispatch = useDispatch();
  const tableRef = useRef(null);
  const [selectall, setSelectAll] = useState(false);
  const multipleSelect = useRef(new Map());
  const [openDelete, setOpenDelete] = useState(false);
  const deleteSelected = useRef(null);
  const deleteChildSelected = useRef(null);
  const [userView, setUserView] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [selectVideos, setSelectVideos] = useState(null);
  const [childMark, setChildMark] = useState(false);
  const [openMulitDelete, setOpenMulitDelete] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [sortColumn, setSortColumn] = useState("");
  const [sortOrder, setSortOrder] = useState("");

  const [loading, setLoading] = useState(true);

  const debouncedSearch = useDebounce(searchInput, 800);


  useEffect(() => {
    // dispatch(fetchTournamentData(token, 1));
    dispatch(
      getAdminAllClubsApi({
        token,
        page: 1,
        search: "",
        sortColumn: "createdAt",
        sortOrder: "DESC",
      }),
    );
  }, [dispatch, token]);

  useEffect(() => {
    setLoading(goalData?.loading);

    // if (goalData?.success) {
    if (goalData?.data?.length > 0) {
      // setGoals("NO Leads!");
      setGoals(goalData?.data);
      setCurrentPage(goalData?.page || 1);
      // setTotalPages(Math.ceil(goalData?.data?.count / 10));
      setTotalPages(Math.ceil(goalData?.count / 10));
    } else {
      setGoals("NO Clubs Found!");
    }
    // } else if (!goalData?.success) {
    //   setGoals(goalData?.message);
    // }
  }, [goalData]);

  const handleChangePage = useCallback(
    (event, newPage) => {
      setCurrentPage(newPage);
      dispatch(
        getAdminAllClubsApi({
          token,
          page: newPage,
          search: debouncedSearch,
          sortColumn: sortColumn,
          sortOrder: sortOrder,
        }),
      );
    },
    [dispatch, token, debouncedSearch, sortColumn, sortOrder],
  );

  useEffect(() => {
    dispatch(
      getAdminAllClubsApi({
        token,
        page: currentPage,
        search: debouncedSearch,
        sortColumn: sortColumn,
        sortOrder: sortOrder,
      }),
    );
  }, [sortColumn, sortOrder, token, dispatch]);

  useEffect(() => {
    dispatch(
      getAdminAllClubsApi({
        token,
        page: 1,
        search: debouncedSearch,
        sortColumn: "",
        sortOrder: "",
      }),
    );
  }, [debouncedSearch]);

  const handleSort = (column) => {
    const isAsc = sortColumn == column && sortOrder == "ASC";
    setSortOrder(isAsc ? "DESC" : "ASC");
    setSortColumn(column);
  };

  const handleSearchClick = useCallback(() => {
    if (debouncedSearch.trim() !== "") {
      dispatch(
        getAdminAllClubsApi({
          token,
          page: 1,
          search: debouncedSearch,
          sortColumn: "",
          sortOrder: "",
        }),
      );
    }
  }, [dispatch, token, debouncedSearch, sortColumn, sortOrder, currentPage]);

  function handleDeleteClose() {
    setOpenDelete(false);
  }

  async function handleDelete() {
    try {
      setDeleteLoading(true);
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/clubs/deleteClub/${deleteSelected.current.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.data.success) {
        dispatch(
          getAdminAllClubsApi({
            token,
            page: currentPage,
            search: debouncedSearch,
            sortColumn: sortColumn,
            sortOrder: sortOrder,
          }),
        );
        toast.success("club deleted successfully");
      }
    } catch (error) {
      toast.error("Please try again..");
    } finally {
      setOpenDelete(false);
      setDeleteLoading(false);
    }
  }

  async function handleTournamentVideoDelete(data) {
    try {
      setDeleteLoading(true);
      if (data.current.id) {
        const response = await axios.delete(
          `${process.env.REACT_APP_API_URL}/clubs/deleteClubVideo/${data.current.id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        if (response.data.success) {
          dispatch(
            getAdminAllClubsApi({
              token,
              page: currentPage,
              search: debouncedSearch,
              sortColumn: sortColumn,
              sortOrder: sortOrder,
            }),
          );
          toast.success("Club video deleted successfully");
          setSelectVideos((prev) => {
            prev.delete(data.current.id);
            return prev;
          });
        }
      } else {
        toast.error("no id found !!");
      }
    } catch (error) {
      toast.error("Please try again..");
    } finally {
      setOpenDelete(false);
    }
  }

  async function handleMultipleDelete() {
    try {
      setDeleteLoading(true);
      const ids = Array.from(multipleSelect.current.entries()).map(
        (ele) => ele[0],
      );
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/clubs/deleteMultipleClubVideos`,
        {
          ids,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response.data.success) {
        // dispatch(
        //   fetchTournamentData(token, currentPage, sortColumn, sortOrder),
        // );
        dispatch(
          getAdminAllClubsApi({
            token,
            page: currentPage,
            search: debouncedSearch,
            sortColumn: sortColumn,
            sortOrder: sortOrder,
          }),
        );
        toast.success("Selected videos deleted successfully");
      }
    } catch (error) {
      toast.error("Please try again..");
    } finally {
      multipleSelect.current.clear();
      setOpenMulitDelete(false);
    }
  }

  return (
    <React.Fragment>
      <ToastContainer />
      <Box className="page_title tournament_title">
        <Typography variant="h1" component="h1">
          Clubs
        </Typography>

        {/* <DeleteOutlineIcon className="delete-icon" /> */}
      </Box>
      <Box className="page_inner">
        <Box className="search_box_wrapper">
          <Box className="search_box">
            <Box className="input-wrapper">
              <SearchIcon className="searchIcon" onClick={handleSearchClick} />
              <input
                placeholder="search by title, club name"
                type="text"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    dispatch(
                      fetchTournamentData(
                        token,
                        1,
                        sortColumn,
                        sortOrder,
                        debouncedSearch,
                      ),
                    );
                  }
                }}
              />
              <Button
                className="delete-search-btn"
                onClick={() => {
                  if (
                    multipleSelect.current &&
                    multipleSelect.current.size > 0
                  ) {
                    setOpenMulitDelete(true);
                  } else {
                    toast.error("Please select at least one video");
                  }
                }}
              >
                <DeleteOutlineIcon className="delete-icon" />
              </Button>
            </Box>
          </Box>
        </Box>
        <Box className="page_table tournament">
          <TableContainer
            component={Paper}
            className="customer_form user_table"
          >
            <Table
              aria-label="leads table"
              id="leadsTable"
              className="display responsive nowrap"
              style={{ width: "100%", minWidth: "900px" }}
            >
              <TableHead className="table_Head">
                <TableRow key="tb_head_tournament">
                  {goalsColumn.map((column) =>
                    column.id != "tournament_select" ? (
                      <TableCell key={column.id}>
                        {columnsToSort.includes(column.id) ? (
                          <TableSortLabel
                            active={sortColumn === column.id}
                            onClick={() => handleSort(column.id)}
                            direction={sortOrder.toLowerCase()}
                          >
                            {column.label}
                          </TableSortLabel>
                        ) : (
                          column.label
                        )}
                      </TableCell>
                    ) : (
                      <TableCell key={column.id}>
                        <Box className="checkbox-td">
                          <input
                            type="checkbox"
                            className="siteCheckBox"
                            checked={selectall}
                            onChange={(e) => {
                              if (!e.target.checked) {
                                multipleSelect.current.clear();
                              }
                              setSelectAll(e.target.checked);
                            }}
                          />
                        </Box>
                      </TableCell>
                    ),
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  Array.from({ length: 10 }).map((e, i) => (
                    <LisitingSkeleton key={i} />
                  ))
                ) : Array.isArray(goals) && goals.length > 0 ? (
                  goals.map((value, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Box className="checkbox-td">
                          <CheckBox
                            multipleSelect={multipleSelect}
                            selectall={selectall}
                            data={value}
                            key={value.id}
                          />
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="property_name">
                          <Typography
                            variant="h4"
                            component="h4"
                            className="t_title"
                          >
                            {value?.title}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="td-wrapper ">
                          <Typography
                            variant="h4"
                            component="h4"
                            className="td-text"
                          >
                            {value?.visibility ? "Public" : "Private"}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="td-wrapper-goalCat">
                          <Typography
                            variant="p"
                            component="p"
                            className="table-text"
                          >
                            {value?.clubCat?.name}
                          </Typography>
                          {value?.clubSubCat && (
                            <Typography
                              variant="p"
                              component="p"
                              className="table-text sub-cat"
                            >
                              {value?.clubSubCat?.name}
                            </Typography>
                          )}
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Box className="td-wrapper">
                          <Typography
                            variant="p"
                            component="p"
                            className="table-text"
                          >
                            {value?.region}
                          </Typography>
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Box className="td-wrapper">
                          <Typography
                            variant="p"
                            component="p"
                            className="table-text"
                          >
                            <a
                              href=""
                              className="tournament_video"
                              onClick={(e) => {
                                e.preventDefault();
                                if (value?.ClubGoals?.length > 0) {
                                  setSelectVideos(
                                    new Map(
                                      value?.ClubGoals?.map((v) => [v.id, v]),
                                    ),
                                  );
                                  setShowVideo(true);
                                }
                              }}
                            >
                              {value?.ClubGoals?.length + " Videos"}
                            </a>
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="td-wrapper">
                          <Typography
                            variant="p"
                            component="p"
                            className="table-text"
                          >
                            {moment(value.createdAt).format(
                              "MMMM Do, YYYY HH:mm",
                            )}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="table-actions">
                          <Box className="action-wrapper">
                            <Button
                              variant="text"
                              className=""
                              sx={{ minWidth: "40px", p: 0 }}
                              onClick={() => {
                                deleteSelected.current = value;
                                setOpenDelete(true);
                              }}
                            >
                              <img src={DeleteIcon} alt="" />
                            </Button>
                            <Button
                              variant="outlined"
                              className="visible_user"
                              onClick={() => {
                                deleteSelected.current = value;
                                setUserView(true);
                              }}
                            >
                              <VisibilityIcon className="visible_icon" />
                            </Button>
                          </Box>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow component={`tr`}>
                    <TableCell colSpan={8} style={{ textAlign: "center" }}>
                      No clubs Found!
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              handleChangePage={handleChangePage}
            />
          )}
        </Box>
      </Box>

      {/* delete club  */}
      <Modal
        open={openDelete}
        onClose={handleDeleteClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="deleteModal">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are You sure . You want to delete this Club.
          </Typography>
          <Box className="buttons-div">
            <Button
              variant="outlined"
              onClick={() => setOpenDelete(false)}
              disabled={deleteLoading}
            >
              cancel
            </Button>
            <Button
              variant="outlined"
              onClick={handleDelete}
              disabled={deleteLoading}
              // loading={deleteLoading}
              loading={deleteLoading}
            >
              {deleteLoading ? "Deleting..." : "Delete"}
            </Button>
          </Box>
        </Box>
      </Modal>

      <ViewClub
        setUserView={setUserView}
        userView={userView}
        deleteSelected={deleteSelected}
      />

      {/* showvideo tournamnet  */}
      <Modal
        open={showVideo}
        onClose={() => setShowVideo(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="deleteModal" sx={{ padding: "0", overflow: "hidden" }}>
          <TableContainer component={Paper}>
            <Table sx={{ width: "100%" }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">THUMB</TableCell>
                  <TableCell align="left">ACTION</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {selectVideos && selectVideos.size > 0
                  ? Array.from(selectVideos.entries())
                      .map((ele) => ele[1])
                      .map((video, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell align="right">
                            {" "}
                            {/* <Box className="tourna_video_model">
                              <Box className="p_image">
                                <ImageWithFallback
                                  src={video.thumbnail}
                                  alt={""}
                                  fallbackSrc={BlankImg}
                                />
                                <Box className="playIcon-wrapper">
                                  <Box
                                    component={Link}
                                    href={video?.video_link}
                                    target="_blank"
                                  >
                                    <PlayArrowIcon className="playIcon" />
                                  </Box>
                                </Box>
                              </Box>
                            </Box> */}
                            <VideoCell
                              link={video?.video_link}
                              thumbnail={video?.thumbnail}
                            />
                          </TableCell>
                          <TableCell align="right">
                            {" "}
                            <Box className="table-actions">
                              <Box className="action-wrapper">
                                <TournamentVideoDeleteModal
                                  deleteSelected={deleteChildSelected}
                                  video={video}
                                  handleTournamentVideoDelete={
                                    handleTournamentVideoDelete
                                  }
                                />
                              </Box>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                  : "no value in state"}
              </TableBody>
            </Table>
          </TableContainer>
          {/* <TournamentVideoDeleteModal /> */}
        </Box>
      </Modal>

      {/* delete multiple video delete modal  */}
      <Modal
        open={openMulitDelete}
        onClose={() => setOpenMulitDelete(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="deleteModal">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are You sure . You want to delete the selected Clubs.
          </Typography>
          <Box className="buttons-div">
            <Button
              variant="outlined"
              onClick={() => setOpenMulitDelete(false)}
              disabled={deleteLoading}
            >
              cancel
            </Button>
            <Button
              variant="outlined"
              onClick={handleMultipleDelete}
              disabled={deleteLoading}
            >
              {deleteLoading ? "Deleting..." : "Delete"}
            </Button>
          </Box>
        </Box>
      </Modal>
    </React.Fragment>
  );
}
